import React from 'react';
import {Col, Row} from "react-bootstrap";
import {t} from "react-switch-lang";
import SelectList from "../../../../../../components/FormFields/select/SelectList";
import {yesNoOptions} from "../../../../../../utils/externalizationFormOptions";
import InputText from "../../../../../../components/FormFields/InputText";

function CriticalExternalizationForm({disabled,proponentFormValues}) {
    return (
        <>
            <Row>
                <Col className="col-6 col-xl-3">
                    <label className="label d-flex align-items-end fileInputLabel w-100 mt-2">
                        {t('externalization.riskProponentForm.serviceProviderOwnedByBank')}
                    </label>
                    <SelectList
                        name="isServiceProviderBankOwned"
                        className="select pt-4"
                        options={yesNoOptions}
                        placeholder={t('externalization.riskProponentForm.serviceProviderOwnedByBank')}
                        isClearable
                        isDisabled={disabled}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.identificationOfAlternativeServiceProvider')}
                    </label>
                    <InputText
                        type="text"
                        name="alternativeServiceProviders"
                        className="form-control input-field"
                        placeholder={t('externalization.riskProponentForm.placeholder.identificationOfAlternativeServiceProvider')}
                        disabled={disabled}
                        id="alternativeServiceProviders"
                        defaultValue={proponentFormValues?.alternativeServiceProviders}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.personResponsibleForApproving')}
                    </label>
                    <InputText
                        type="text"
                        name="externalizationApprovingAuthority"
                        className="form-control input-field"
                        placeholder={t('externalization.riskProponentForm.placeholder.personResponsibleForApproving')}
                        disabled={disabled}
                        id="externalizationApprovingAuthority"
                        defaultValue={proponentFormValues?.externalizationApprovingAuthority}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.estimatedAnnualCosts')}
                    </label>
                    <InputText
                        type="text"
                        name="estimatedAnnualCostAmount"
                        className="form-control input-field"
                        placeholder={t('externalization.riskProponentForm.placeholder.estimatedAnnualCosts')}
                        disabled={disabled}
                        id="estimatedAnnualCostAmount"
                        defaultValue={proponentFormValues?.estimatedAnnualCostAmount}
                    />
                </Col>
            </Row>
            <Row>
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.resultsOfTheLatestRiskAssessment')}
                        <span className="optional register line-height">{t('common.optional')} </span>
                    </label>
                    <InputText
                        type="text"
                        name="lastExternalizationRelatedRiskAssessmentResults"
                        className="form-control input-field"
                        placeholder={t('externalization.riskProponentForm.placeholder.resultsOfTheLatestRiskAssessment')}
                        disabled={disabled}
                        id="lastExternalizationRelatedRiskAssessmentResults"
                        defaultValue={proponentFormValues?.lastExternalizationRelatedRiskAssessmentResults}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.criticalAndImportantFunctionSupports')}
                    </label>
                    <SelectList
                        name="supportsTimeCriticalOperations"
                        className="select"
                        options={yesNoOptions}
                        placeholder={t('externalization.riskProponentForm.placeholder.criticalAndImportantFunctionSupports')}
                        isClearable={false}
                        id="supportsTimeCriticalOperations"
                        isDisabled={disabled}
                        defaultValue={proponentFormValues?.supportsTimeCriticalOperations}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.jurisdiction')}
                    </label>
                    <InputText
                        type="text"
                        name="disputeResolutionJurisdiction"
                        className="form-control input-field"
                        placeholder={t('externalization.riskProponentForm.placeholder.jurisdiction')}
                        disabled={disabled}
                        id="disputeResolutionJurisdiction"
                        defaultValue={proponentFormValues?.disputeResolutionJurisdiction}
                    />
                </Col>
                <Col className="col-6 col-xl-3">
                    <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.assessmentOfDiscontinuationImpact')}
                    </label>
                    <InputText
                        type="text"
                        name="assessmentOfDiscontinuationImpact"
                        className="form-control input-field"
                        placeholder={t('externalization.riskProponentForm.placeholder.assessmentOfDiscontinuationImpact')}
                        disabled={disabled}
                        id="assessmentOfDiscontinuationImpact"
                        defaultValue={proponentFormValues?.assessmentOfDiscontinuationImpact}
                    />
                </Col>
            </Row></>
    );
}

export default CriticalExternalizationForm;